<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import type { ICompanyOwnershipDTO } from "../../services/DTO";
  import type { IOwnership } from "../../entities";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import Textarea from "../Form/Fields/Textarea.svelte";
  import Button from "../../components/Button.svelte";
  import OwnershipDropdown from "../Form/Fields/Dropdown/OwnershipDropdown.svelte";
  import FormField from "../Form/FormField.svelte";
  import Icon from "../Icon.svelte";

  export let ownerships: ICompanyOwnershipDTO[] = [];
  export let entityId: number = 0;
  export let disabled: boolean = false;

  let ownOid = 0;
  let ownOidToAdd = 0;

  const dispatch = createEventDispatcher();

  function onLoad() {
    dispatch("load", { entityId: entityId });
  }

  function onEdit(own: ICompanyOwnershipDTO) {
    ownOid = own.oid;
  }

  function onSave() {
    let owner = {
      oid: ownOid,
      entityId: entityId,
      ownership: {oid: ownOidToAdd} as IOwnership
    } as ICompanyOwnershipDTO;
    dispatch("save", owner);
    ownOid = 0;
    ownOidToAdd = 0;
  }

  function onDelete(owner: ICompanyOwnershipDTO) {
    dispatch("delete", owner);
  }

  onMount(() => onLoad());
</script>

<div class="box">
  <h1 class="subtitle">Aziende proprietarie</h1>
  {#if !disabled}
  <FormField>
  <div class="columns">
    <div class="column is-8">
      <OwnershipDropdown
        placeholder="aggiungi proprietario"
        required={false}
        {disabled}
        bind:value={ownOidToAdd}
      />
    </div>
    <div class="column is-5">
      <Button on:click={onSave} {disabled} >Aggiungi</Button>
    </div>
  </FormField>
  {/if}

  {#each ownerships as own}
    <hr class="comment-separator" />
    <div class="comment-info">
      {own.ownership.name}
    </div>
  {/each}
</div>

<style>
  .comment-separator {
    margin: 4px 0;
  }
  .comment-info {
    position: relative;
  }
  .comment-info-text {
    color: #999;
    font-size: x-small;
    display: inline-block;
    position: absolute;
    top: 4px;
    margin-left: 5px;
  }
</style>
